module.exports = __webpack_public_path__ + "img/royal hospitals indoor shoot-34.5e7bf687.webp";